// extracted by mini-css-extract-plugin
export var result = "webform-module--result--259a4";
export var webform_wrapper = "webform-module--webform_wrapper--9efbf";